export default "__VITE_ASSET__OrkDW2$H__"